module.exports = __webpack_public_path__ + "img/time-money.834dc82a.svg";